import Link from "next/link";
import Image from "next/image";
import { FeaturedCard as FeaturedCardType } from "./types";
import { trackFeaturedCardClick } from "@/utils/analytics";

interface FeaturedCardProps {
  card: FeaturedCardType;
  menuId: string;
  /** When false, keep the link/title in HTML but skip image bytes / preloads. */
  loadMedia?: boolean;
}

function normalizeImageUrl(value: string): string {
  const trimmed = value.trim();
  if (trimmed.startsWith("//")) return `https:${trimmed}`;
  return trimmed;
}

export default function FeaturedCard({
  card,
  menuId,
  loadMedia = false,
}: FeaturedCardProps) {
  const handleClick = () => {
    trackFeaturedCardClick({
      menu: menuId,
      cardTitle: card.title,
      cardUrl: card.url,
    });
  };

  return (
    <Link
      href={card.url}
      key={card.title}
      onClick={handleClick}
      className="group block relative rounded-lg overflow-hidden bg-gray-100 w-full [aspect-ratio:3/2] lg:[aspect-ratio:5/6]"
    >
      {loadMedia ? (
        <Image
          src={normalizeImageUrl(card.imageSrc)}
          alt={card.imageAlt}
          fill
          sizes="(min-width: 1024px) 12rem, 40vw"
          className="rounded-lg object-cover group-hover:opacity-75"
        />
      ) : null}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 z-[1] bg-gradient-to-t from-gray-900 to-transparent"
      />
      <p className="absolute bottom-3 left-2 right-2 z-[2] mt-0 text-xs font-semibold text-white">
        {card.title}
      </p>
    </Link>
  );
}
